<nav #navbar class="navbar navbar-expand-lg navbar-absolute fixed-top">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="logo">
        <a class="simple-text logo-mini">
          <div class="logo-img">
            <!-- <img src="assets/img/hostel HR negativo.png"/> -->
            <img src="assets/img/marca Lives negativo - alta.png" class="lives-hr-logo" />
          </div>
        </a>
      </div>
      <div class="navbar-minimize">
      </div>
    </div>
    <button 
    mat-button 
    class="navbar-toggler btn-no-ripple" 
    type="button" 
    (click)="sidebarToggle()"
    >
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="justify-content-end" id="navigation" *ngIf="isMobileMenu()">
      <ul class="navbar-nav navbar-right">
        <li class="nav-item">

        </li>
      </ul>
    </div>

    <div class="horizontalLayout headerUserSection" *ngIf="isMobileMenu()">
      <div class="colAuto">
        <a 
        class="headerActionIcon" 
        id="navbarDropdownContact" 
        data-toggle="dropdown" 
        aria-haspopup="true"
          aria-expanded="false" 
          placement="bottom" 
          ngbTooltip="Soporte" 
          (click)="redirectLCX()"
          >
          <fa-icon [icon]="'comment'" size="lg"></fa-icon>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownContact"
        >
          <div class="container">
            Soporte telefónico 928050050 / 922050050
          </div>
        </div>
      </div>
      <div class="colAuto">
        <a href="https://addons.linksoluciones.com/wp-content/uploads/2023/01/Manual-Usuario-HostelHR.pdf"
          target="blank" class="headerActionIcon" placement="bottom" ngbTooltip="manual de usuario">
          <fa-icon [icon]="['fas', 'question']" size="lg"></fa-icon>
        </a>
      </div>
      <div class="colAuto headerUserData ml-3">
        <div class="userNameText" id="headerUsername">
          {{ usuario && usuario.Name }}
        </div>
        <div class="idCDAtext" id="txtIDCDA">
          {{ empresa && empresa }}
        </div>
      </div>
      <!-- <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Dropdown button
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <a class="dropdown-item" href="#">Something else here</a>
        </div>
      </div> -->
      <div class="colAuto">
        <a
          href="javascript:void(0)"
          id="navbarDropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="headerUserPhoto alignMiddle">
            <i class="material-icons md-36">account_circle</i>
          </div>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownMenuLink"
        >
          <a class="dropdown-item" href="login" (click)="logOutClick()"
            ><i _ngcontent-axr-c2="" class="material-icons">exit_to_app</i>
            &nbsp; Cerrar sesión</a
          >
        </div>
      </div>
    </div>
  </div>
</nav>
